import React, {Component} from 'react';
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl';

import TextField from 'material-ui/TextField';
import CountrySelector from '../presentational/elements/countrySelector';

class AddressForm extends Component {
    render() {
        return (
            <div>
                <form>
                    <TextField
                        name="line_1"
                        ref="line_1"
                        id="address_line_1"
                        style={this.props.styles.textField}
                        defaultValue={this.props.line_1}
                        hintText={
                            <FormattedMessage
                                id="checkout.addressLine1"
                                defaultMessage="Address line 1"
                            />
                        }
                        errorText={this.props.errors.line_1}
                        onChange={this.props.handleAddressUpdate}
                    />
                    <TextField
                        name="line_2"
                        ref="line_2"
                        id="address_line_2"
                        className="formLines"
                        defaultValue={this.props.line_2}
                        hintText={
                            <FormattedMessage
                                id="checkout.addressLine1"
                                defaultMessage="Address line 2"
                            />
                        }
                        onChange={this.props.handleAddressUpdate}
                    />
                    <TextField
                        name="city"
                        ref="city"
                        id="address_city"
                        className="formLines"
                        defaultValue={this.props.city}
                        hintText={
                            <FormattedMessage
                                id="checkout.city"
                                defaultMessage="City"
                            />
                        }
                        errorText={this.props.errors.city}
                        onChange={this.props.handleAddressUpdate}
                    />
                    <TextField
                        name="zip"
                        ref="zip"
                        id="address_zip"
                        className="formLines"
                        defaultValue={this.props.zip}
                        hintText={
                            <FormattedMessage
                                id="checkout.postalCode"
                                defaultMessage="ZIP / Postal code"
                            />
                        }
                        errorText={this.props.errors.zip}
                        onChange={this.props.handleAddressUpdate}
                    />
                    <TextField
                        name="state"
                        ref="state"
                        id="address_state"
                        className="formLines"
                        defaultValue={this.props.state}
                        hintText={
                            <FormattedMessage
                                id="checkout.state"
                                defaultMessage="State / County"
                            />
                        }
                        onChange={this.props.handleAddressUpdate}
                    />
                    <CountrySelector name="country"
                                     id="address_country"
                                     className="billingCountry"
                                     value={this.props.country}
                                     onChange={this.props.handleCountryUpdate}
                    />
                </form>
            </div>
        )
    }
}

AddressForm.propTypes = {
    handleAddressUpdate: PropTypes.func.isRequired,
    handleCountryUpdate: PropTypes.func.isRequired,
    line_1: PropTypes.string.isRequired,
    line_2: PropTypes.string.isRequired,
    city: PropTypes.string.isRequired,
    zip: PropTypes.string.isRequired,
    state: PropTypes.string.isRequired,
    country: PropTypes.string.isRequired,
    styles: PropTypes.object,
    errors: PropTypes.object
};

export default AddressForm